import React, { Fragment } from "react";
import DataTable, { Row } from "../DataTable.jsx";

import { RS485Module } from "./modules/RS485Module.jsx";
import { RS232Module } from "./modules/RS232Module.jsx";
import { TCPModule } from "./modules/TCPModule.jsx";

import { MULTILOOP_MODULE_NAMES } from "../const.js";
import { useHwaddrAndNetworkIdFromRouter, usePanelModuleFromRouter, useZones } from "../store/panelsSlice.js";


export const MODULE_UI_MAP = {

    // "MOD_MRKII": "Loop Card",
    // "MOD_MIM_CLASS_B": "Multi Input Unit",
    // "MOD_ZMU_CLASS_A": "Zone Monitor",
    // "MOD_ZMU_CLASS_B": "Zone Monitor",
    // "MOD_MRM": "Multi Relay Output",
    // "MOD_NAC_CLASS_A": "Alarm Circuit",
    // "MOD_NAC_CLASS_B": "Alarm Circuit",
    
    "MOD_NWM": RS485Module,

    // "MOD_MBM": "MOD_MBM",
    
    "MOD_232": RS232Module,
    "MOD_TCP": TCPModule,
    
    // "MOD_GAS": "Gas Loop",
    // "MOD_STD": "Standard Loop",
    // "MOD_CO": "CO Loop",
}

export const FakeModuleComponent = () => (
    <Fragment>
        <Row label="Edit option 1"> <input className="form-control" /></Row>
        <Row label="Edit option 2"> <input className="form-control" /></Row>
        <Row label="Edit option 3" > <input className="form-control" /></Row>
    </Fragment>
);

export const ModuleEditor = props => {

    const panelModule = usePanelModuleFromRouter();
    const zoneData = useHwaddrAndNetworkIdFromRouter(useZones);

    if (!panelModule) {
        return <p>Loading module editor...</p>;
    }

    let moduleEditor = null;
    if(panelModule.port_type in MODULE_UI_MAP)
    {
        const ModuleComponent = MODULE_UI_MAP[panelModule.port_type]
        moduleEditor = (
            <DataTable>
                <Row label="ID">{panelModule.port_id}</Row>
                <Row label="Type">{(panelModule.port_type in MULTILOOP_MODULE_NAMES) ? MULTILOOP_MODULE_NAMES[panelModule.port_type] : panelModule.port_type}</Row>
                <ModuleComponent module={panelModule} />
                {/* <Row label="Debug" noParagraph>
                    <details>
                        <summary>Raw data</summary>
                        <pre>{JSON.stringify(panelModule, null, 2)}</pre>
                    </details>
                </Row> */}
            </DataTable>
        );
    }else{
        moduleEditor = (
            <DataTable>
                <Row label="ID">{panelModule.port_id}</Row>
                <Row label="Type">{MULTILOOP_MODULE_NAMES[panelModule.port_type]}</Row>
                {/* <Row label="Debug" noParagraph>
                    <details>
                        <summary>Raw data</summary>
                        <pre>{JSON.stringify(panelModule, null, 2)}</pre>
                    </details>
                </Row> */}
            </DataTable>
        );
    }
    
    return <Fragment>
        {moduleEditor}
        
        {panelModule.devices.length > 0
            ?
            (
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Zone</th>
                            <th>Name</th>
                            <th></th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        {panelModule.devices.map((d) => (
                            <tr key={d.mod_idx}>
                                <td>{d.type}</td>
                                <td>{zoneData.find( z => z.id == d.zone).name}</td>
                                <td>{d.name}</td>
                                <td>
                                    <a role="button" className="btn btn-primary" href={`#${props.match.url}/device/${d.mod_idx}`}>Edit</a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )
            :
            null}
    </Fragment>;
};
